import React from 'react';

export function DiningColoredIcon({ className, width = 36, height = 36 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.3162 17.5353C33.3162 26.251 26.2505 33.3167 17.5348 33.3167C8.8191 33.3167 1.75342 26.251 1.75342 17.5353C1.75342 8.81959 8.8191 1.75391 17.5348 1.75391C26.2505 1.75391 33.3162 8.81959 33.3162 17.5353Z"
        fill="#E1E8ED"
      />
      <path
        d="M28.0555 17.5356C28.0555 23.3466 23.3457 28.0565 17.5346 28.0565C11.7235 28.0565 7.01367 23.3466 7.01367 17.5356C7.01367 11.7245 11.7235 7.01465 17.5346 7.01465C23.3457 7.01465 28.0555 11.7245 28.0555 17.5356Z"
        fill="#CCD6DD"
      />
      <path
        d="M27.179 17.5348C27.179 22.861 22.861 27.179 17.5348 27.179C12.2077 27.179 7.89062 22.861 7.89062 17.5348C7.89062 12.2077 12.2086 7.89062 17.5348 7.89062C22.861 7.89062 27.179 12.2077 27.179 17.5348Z"
        fill="#E1E8ED"
      />
      <path
        d="M2.63016 3.50739C3.11437 3.50739 3.50691 3.11486 3.50691 2.63065C3.50691 2.14644 3.11437 1.75391 2.63016 1.75391C2.14595 1.75391 1.75342 2.14644 1.75342 2.63065C1.75342 3.11486 2.14595 3.50739 2.63016 3.50739Z"
        fill="#99AAB5"
      />
      <path
        d="M1.75342 2.63086H3.50691V8.76807H1.75342V2.63086Z"
        fill="#99AAB5"
      />
      <path
        d="M6.137 3.50739C6.62121 3.50739 7.01374 3.11486 7.01374 2.63065C7.01374 2.14644 6.62121 1.75391 6.137 1.75391C5.65279 1.75391 5.26025 2.14644 5.26025 2.63065C5.26025 3.11486 5.65279 3.50739 6.137 3.50739Z"
        fill="#99AAB5"
      />
      <path
        d="M5.26025 2.63086H7.01374V8.76807H5.26025V2.63086Z"
        fill="#99AAB5"
      />
      <path
        d="M9.64432 3.50739C10.1285 3.50739 10.5211 3.11486 10.5211 2.63065C10.5211 2.14644 10.1285 1.75391 9.64432 1.75391C9.16011 1.75391 8.76758 2.14644 8.76758 2.63065C8.76758 3.11486 9.16011 3.50739 9.64432 3.50739Z"
        fill="#99AAB5"
      />
      <path
        d="M8.76751 2.63086H10.521V8.76807H8.76751V2.63086ZM4.38379 14.0285H7.89077V31.5634H4.38379V14.0285Z"
        fill="#99AAB5"
      />
      <path
        d="M6.13728 33.3165C7.1057 33.3165 7.89077 32.5315 7.89077 31.5631C7.89077 30.5946 7.1057 29.8096 6.13728 29.8096C5.16885 29.8096 4.38379 30.5946 4.38379 31.5631C4.38379 32.5315 5.16885 33.3165 6.13728 33.3165Z"
        fill="#99AAB5"
      />
      <path
        d="M8.76737 8.76758C8.76737 9.25154 8.37459 9.64432 7.89063 9.64432C7.40666 9.64432 7.01388 9.25154 7.01388 8.76758H5.26039C5.26039 9.25154 4.86761 9.64432 4.38365 9.64432C3.89969 9.64432 3.50691 9.25154 3.50691 8.76758H1.75342C1.75342 12.1571 2.63016 14.9048 6.13714 14.9048C9.64411 14.9048 10.5209 12.1571 10.5209 8.76758H8.76737Z"
        fill="#99AAB5"
      />
      <path
        d="M2.63016 9.64509C3.11437 9.64509 3.50691 9.25256 3.50691 8.76835C3.50691 8.28413 3.11437 7.8916 2.63016 7.8916C2.14595 7.8916 1.75342 8.28413 1.75342 8.76835C1.75342 9.25256 2.14595 9.64509 2.63016 9.64509Z"
        fill="#99AAB5"
      />
      <path
        d="M6.137 9.64509C6.62121 9.64509 7.01374 9.25256 7.01374 8.76835C7.01374 8.28413 6.62121 7.8916 6.137 7.8916C5.65279 7.8916 5.26025 8.28413 5.26025 8.76835C5.26025 9.25256 5.65279 9.64509 6.137 9.64509Z"
        fill="#99AAB5"
      />
      <path
        d="M9.64432 9.64509C10.1285 9.64509 10.5211 9.25256 10.5211 8.76835C10.5211 8.28413 10.1285 7.8916 9.64432 7.8916C9.16011 7.8916 8.76758 8.28413 8.76758 8.76835C8.76758 9.25256 9.16011 9.64509 9.64432 9.64509Z"
        fill="#99AAB5"
      />
      <path
        d="M28.0557 14.0283H31.5626V31.5632H28.0557V14.0283Z"
        fill="#99AAB5"
      />
      <path
        d="M29.8092 33.3165C30.7776 33.3165 31.5626 32.5315 31.5626 31.5631C31.5626 30.5946 30.7776 29.8096 29.8092 29.8096C28.8407 29.8096 28.0557 30.5946 28.0557 31.5631C28.0557 32.5315 28.8407 33.3165 29.8092 33.3165Z"
        fill="#99AAB5"
      />
      <path
        d="M29.809 1.75391C30.6858 1.75391 31.5625 2.63065 31.5625 4.38414V18.412C31.5625 18.412 25.4253 20.1655 25.4253 11.3981C25.4253 6.13763 28.0555 1.75391 29.809 1.75391Z"
        fill="#99AAB5"
      />
    </svg>
  );
}
